// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"70746da6","198":"70746da6"}[chunkId] + ".chunk.css";
};